import { FormatStyle } from "./enums/SaveMode";
import { ModelMapAbstract } from "./ModelMapAbstract";
export class CabBookingModel { }


export interface CabBookingMaster {
    CabRequestID: number;
    EmployeeID: number;
    CompanyName: string;
    DepartmentName: string;
    DesignationName: string;
    SiteName: string;
    ContactNumber:string;
    EmployeeCode: string;
    PlantCode: string;
    PlantName: string;
    Location: string;
    FromLocation: string;
    ToLocation: string;
    FromDate: Date;
    ToDate: Date;
    TravelDate: Date;
    NoOfPerson: number;
    ReasonForTravel: string;
    IsActive: boolean;
    IsCancel: boolean;
    CancelDateTime: Date;
    IsApproved: boolean;
    IsRejected: boolean;
    RequestStatus: number;
    CreatedBy: number;
    CreatedDate: Date;
    UpdateBy: number;
    UpdateDate: Date;
    CancelUserBy: number;
    OtherRemark: string; //rohit 20-07-2023
    RMName:string;  //rohit 20-07-2023
    CabDurationId: number; //rohit 26-07-2023
    LocationTypeId: number; //rohit 26-07-2023
    CabDuration: number;
    LocationType : string;
    LocationId: number;
    RequestTypeId: number;
    DistanceId: number;
    TravelTypeId:number;
    TravelType:string;

    //PlantTypeID:number;
    //CabDuration: number; //rohit 26-07-2023
    //LocationType: string; //rohit 26-07-2023
}

export interface CabBookingMasterDTO
{
  id : number;
  Name: string;

}


export interface CabAllocationMaster {
    CurrentPage: number;
    PageSize: number;
    UserID: number;
    EmployeeCode: string;
    DepartmentID: number;
    DesignationID: number;
    SiteID: number;
    DriverName: string;
    AllocateStatus: string;
}



export class CabAllocationList {
    EmployeeID: number;
    CabAllocateID: number;
    CabRequestID: number;
    EmployeeName: string;
    EmployeeCode: string;
    SiteID: number;
    DesignationName: string;
    DepartmentName: string;
    PlantCode: string;
    SiteName: string;
    CompanyName: string;
    FromLocation: string;
    ToLocation: string;
    FromDate: Date;
    ToDate: Date;
    TravelDate: string;
    NoOfPerson: number;
    ReasonForTravel: string;
    DriverID: number;
    VehicleID: number;
    DriverName: string;
    DriverNumber:string;
    ContactNumber: string;
    RTONumberPlate: string;
    AllocateStatus: string;
    ApproverName:string;
    ApproverRemarks:string;
    ApprovedDate:string;
    Status: string;
    StatusClass: string;
    Remarks: string;
    TripStatus: string;
    TripRemarks: string;
    CreatedBy: number;
    CreatedDate: Date;
    UpdateBy: number;
    UpdateDate: Date;
    IsEdit:boolean;
    cabAllocationDetail:Array<CabAllocationDetail>;
    RMName: string; //rohit 20-07-2023
    OtherRemark: string; //rohit 20-07-2023
    CabDuration: number; //rohit 26-07-2023
    LocationType: string; //rohit 26-07-2023
    IsApproved:string;
    IsRejected:string;
    CabRequestStatus:string;
    LocationId: number;
    RequestTypeId: number;
    DistanceId: number;
    Location: string;
    RequestedType: string;
    Distance: string;
    TravelTypeId:number;
    TravelType:string;



}

export class CabAllocationDetail{
    CADetailID:number;
    CabAllocateID:number;
    VehicleID:number;
    DriverID:number;
    AssignSeat:number;
    CreatedBy:number;
    CreatedDate:Date;
}


export class ShowCabRequest {
    EmployeeID: number;
    CabAllocateID: number;
    CabRequestID: number;
    EmployeeName: string;
    EmployeeCode: string;
    SiteID: number;
    DesignationName: string;
    DepartmentName: string;
    PlantCode: string;
    SiteName: string;
    CompanyName: string;
    FromLocation: string;
    ToLocation: string;
    FromDate: Date;
    ToDate: Date;
    TravelDate: string;
    NoOfPerson: number;
    ReasonForTravel: string;
    DriverName: string;
    DriverNumber:string;
    ContactNumber: string;
    RTONumberPlate: string;
    AllocatedBy:string;
    AllocatedDate:string;
    ApprovedBy:string;
    ApprovedDate:string;
    ApprovedRemarks:string;
    CabRequestStatus:string;
    InwardBy:string;
    InwardDate:string;
    InwardRemarks:string;
    IsCabInword:boolean;
    IsCaboutword:boolean;
    OutwardBy:string;
    OutwardDate:string;
    OutwardRemarks:string;
    AllocateStatus: string;
    Status: string;
    StatusClass: string;
    Remarks: string;
    TripStatus: string;
    TripRemarks: string;
    CreatedBy: number;
    CreatedDate: Date;
    UpdateBy: number;
    UpdateDate: Date;
    OtherRemark: string; //rohit 20-07-2023
    CabDuration: number; //rohit 26-07-2023
    LocationType: string; //rohit 26-07-2023
    LocationId: number;
    RequestTypeId: number;
    DistanceId: number;
    Location : string;
    RequestedType: string;
    Distance: string;
    TravelTypeId:number;
    TravelType:string;
}



export class CabInwardOutwardList {
    EmployeeID: number;
    ID: number;
    VehicleID: number;
    VehicleName:string;
    VehicleCode:string;
    IsCabInword:string;
    InwardRemarks:string;
    IsCaboutword:string;
    OutwardRemarks:string;
    CabGateStatus:string;
    CabAllocateID: number;
    CabRequestID: number;
    EmployeeName: string;
    EmployeeCode: string;
    AllocatedBy: string;
    AllocatedDate: Date;
    ApprovedBy: string;
    ApprovedDate: Date;
    ApprovedRemarks: string;
    InwardBy: string;
    InwardDate: Date;
    NoOfPerson: number;
    OutwardBy: string;
    OutwardDate: Date;
    DesignationName: string;
    DepartmentName: string;
    PlantCode: string;
    SiteName: string;
    CompanyName: string;
    FromLocation: string;
    ToLocation: string;
    FromDate: Date;
    ToDate: Date;
    TravelDate: string;
    ReasonForTravel: string;
    DriverName: string;
    DriverNumber:string;
    ContactNumber: string;
    RTONumberPlate: string;
    AllocateStatus: string;
    Status: string;
    StatusClass: string;
    Remarks: string;
    TripStatus: string;
    TripRemarks: string;
    CreatedBy: number;
    CreatedDate: Date;
    UpdateBy: number;
    UpdateDate: Date;
    Location : string;
    LocationId : number;
}




export class ViewCabRequest {
    EmployeeID: number;
    CabAllocateID: number;
    CabRequestID: number;
    EmployeeName: string;
    EmployeeCode: string;
    FromLocation: string;
    ToLocation: string;
    FromDate: Date;
    ToDate: Date;
    TravelDate: string;
    NoOfPerson: number;
    ContactNumber: string;
    IsApproved:boolean;
    IsRejected:boolean;
    IsCancel:boolean;
    IsAllocated:boolean;
    Status: string;
    StatusClass: string;
    Remarks: string;
    OtherRemark: string; //rohit 20-07-2023
    CabDurationId: number; //rohit 26-07-2023
    LocationTypeId: number; //rohit 26-07-2023
    LocationType: string;
    LocationId: number;
    RequestTypeId: number;
    DistanceId: number;
    Location : string;
    RequestType: string;
    Distance: string;
    FAStatus: number;
    WFID: number;
    AType: number;
    TravelTypeId:number;
    TravelType:string;
    ApprovalStatus:string;
    
}


export class CabBookingRequestModelMap implements ModelMapAbstract {
    fieldSettings: (string | number)[][] = [
      ['Employee Code', 'EmployeeCode', FormatStyle.None],
      ['Employee Name', 'EmployeeName', FormatStyle.None],
      ['Designation', 'DesignationName', FormatStyle.None],
      ['Department', 'DepartmentName', FormatStyle.None],
      ['SiteName', 'SiteName', FormatStyle.None],
      ['CompanyName', 'CompanyName', FormatStyle.None],
      ['Contact No', 'ContactNumber', FormatStyle.None],
      ['From Location', 'FromLocation', FormatStyle.None],
      ['To Location', 'ToLocation', FormatStyle.None],
      ['From Date', 'FromDate', FormatStyle.DDMMYYYY],
      ['To Date', 'ToDate', FormatStyle.DDMMYYYY],
      ['Travel Date', 'TravelDate', FormatStyle.DDMMYYYY],
      ['Plant/Unit', 'UnitName', FormatStyle.None], 
      ['Reason For Travel', 'ReasonForTravel', FormatStyle.None], 
      ['Other Remark' , 'OtherRemark', FormatStyle.None], // rohit 20-07-2023
      ['CabDuration' , 'CabDuration', FormatStyle.None], // rohit 28-07-2023
      ['LocationType' , 'LocationType', FormatStyle.None], // rohit 28-07-2023
      ['No Of Person', 'NoOfPerson', FormatStyle.None], 
      ['Status', 'Status', FormatStyle.None],        
    ];
  }
  



export class CabBookingModelMap implements ModelMapAbstract {
    fieldSettings: (string | number)[][] = [
      ['Employee Code', 'EmployeeCode', FormatStyle.None],
      ['Employee Name', 'EmployeeName', FormatStyle.None],
      ['Designation', 'DesignationName', FormatStyle.None],
      ['Department', 'DepartmentName', FormatStyle.None],
      ['SiteName', 'SiteName', FormatStyle.None],
      ['CompanyName', 'CompanyName', FormatStyle.None],
      ['Contact No', 'ContactNumber', FormatStyle.None],
      ['From Location', 'FromLocation', FormatStyle.None],
      ['To Location', 'ToLocation', FormatStyle.None],
      ['From Date', 'FromDate', FormatStyle.DDMMYYYY],
      ['To Date', 'ToDate', FormatStyle.DDMMYYYY],
      ['Travel Date', 'TravelDate', FormatStyle.DDMMYYYY],
      // ['Plant/Unit', 'UnitName', FormatStyle.None],  
      ['Plant/Unit', 'PlantCode', FormatStyle.None],  
      ['Reason For Travel', 'ReasonForTravel', FormatStyle.None],
      ['Other Remark' , 'OtherRemark', FormatStyle.None], // rohit 20-07-2023
      ['CabDuration' , 'CabDuration', FormatStyle.None], // rohit 28-07-2023
      ['LocationType' , 'LocationType', FormatStyle.None], // rohit 28-07-2023
      ['Approver Name', 'ApproverName', FormatStyle.None],
      ['Approver Remarks', 'ApproverRemarks', FormatStyle.None],
      ['Approved Date', 'ApprovedDate', FormatStyle.DDMMYYYY],

      ['Driver', 'DriverName', FormatStyle.None],
      ['Driver Number', 'DriverNumber', FormatStyle.None],
      ['Vehicle Name', 'VehicleName', FormatStyle.None],
      ['Vehicle Number', 'RTONumberPlate', FormatStyle.None],
      ['No Of Person', 'NoOfPerson', FormatStyle.None],
      // ['AllocateStatus', 'AllocateStatus', FormatStyle.None],
      ['Status', 'Status', FormatStyle.None]
          
    ];
  }
  


  export class CabInOutModelMap implements ModelMapAbstract {
    fieldSettings: (string | number)[][] = [
      ['Vehicle Code', 'VehicleCode', FormatStyle.None],
      ['Vehicle Name', 'VehicleName', FormatStyle.None],
      ['Cab Inward', 'IsCabInword', FormatStyle.None],
      ['Inward Date', 'FromDate', FormatStyle.None],
      ['Inward Remarks', 'InwardRemarks', FormatStyle.None],
      ['Cab Outward', 'IsCaboutword', FormatStyle.None],
      ['Outward Remarks', 'OutwardRemarks', FormatStyle.None],
      ['Outward Date', 'ToDate', FormatStyle.None],
      ['Cab Gate Status', 'CabGateStatus', FormatStyle.None],
      ['Status', 'Status', FormatStyle.None]
    ];
  }
